var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgB2BSaas(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "506px",
    height: "426px",
    viewBox: "0 0 506 426",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 12@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "4.74880552e-14%",
    y1: "14.5604524%",
    x2: "100%",
    y2: "85.4395476%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07C8F9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D41E1",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Website-Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Barlow-Marshall---Home-V2",
    transform: "translate(-179.000000, -3562.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(179.000000, 3562.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M475.316767,0.5 C483.652107,0.5 490.766947,3.42091197 496.661061,9.26347341 C502.553381,15.1043301 505.5,22.1547611 505.5,30.4150879 L505.5,30.4150879 L505.5,395.584899 C505.5,403.845181 502.553381,410.895622 496.661064,416.736469 C490.766948,422.579001 483.652108,425.5 475.316767,425.5 L475.316767,425.5 L30.6832075,425.5 C22.3478379,425.5 15.2329689,422.579002 9.33890234,416.736471 C3.44655577,410.895622 0.5,403.84518 0.5,395.584899 L0.5,395.584899 L0.5,30.4150879 C0.5,22.1547617 3.44655572,15.1043306 9.33890259,9.26347416 C15.2329696,3.42091087 22.3478387,0.5 30.6832075,0.5 L30.6832075,0.5 Z",
    id: "Rectangle",
    stroke: "#2283FB",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.194826,252.176265 C165.682338,235.86649 186.291568,193.31711 235.746024,178.56928 C285.198327,163.819334 361.988921,185.717521 404.924167,172.974525 C447.86782,160.233646 505,111 505,111 L505,406.105961 C505,416.539666 496.541368,425 486.109878,425 L21.9890699,425 C10.3967852,425 1,415.601214 1,404.006619 L1,272.76024 C1,272.76024 74.7052725,268.485978 120.194826,252.176265 Z",
    id: "Shape",
    stroke: "#2283FB",
    fill: "#E9F3FF",
    transform: "translate(253.000000, 268.000000) scale(-1, 1) translate(-253.000000, -268.000000) "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(243.000000, 161.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5010323,31 C24.0610449,31 31,24.0606314 31,15.5 C31,6.9393686 24.0610449,0 15.5010323,0 C6.9410209,0 0,6.9393686 0,15.5 C0,24.0606314 6.9410209,31 15.5010323,31 L15.5010323,31 Z",
    id: "Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5010323,31 C24.0610449,31 31,24.0606314 31,15.5 C31,6.9393686 24.0610449,0 15.5010323,0 C6.9410209,0 0,6.9393686 0,15.5 C0,24.0606314 6.9410209,31 15.5010323,31 L15.5010323,31 Z",
    id: "Shape",
    stroke: "#2283FB",
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("path", {
    d: "M37,185 L59,185 C61.209139,185 63,186.790861 63,189 L63,391 L63,391 L33,391 L33,189 C33,186.790861 34.790861,185 37,185 Z",
    id: "Rectangle",
    fill: "#2283FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37,273 L59,273 C61.209139,273 63,274.790861 63,277 L63,391 L63,391 L33,391 L33,277 C33,274.790861 34.790861,273 37,273 Z",
    id: "Rectangle-Copy-8",
    fill: "#0156BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263,273 L285,273 C287.209139,273 289,274.790861 289,277 L289,391 L289,391 L259,391 L259,277 C259,274.790861 260.790861,273 263,273 Z",
    id: "Rectangle-Copy-10",
    fill: "#0156BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37,324 L59,324 C61.209139,324 63,325.790861 63,328 L63,391 L63,391 L33,391 L33,328 C33,325.790861 34.790861,324 37,324 Z",
    id: "Rectangle-Copy-9",
    fill: "#003056"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263,324 L285,324 C287.209139,324 289,325.790861 289,328 L289,391 L289,391 L259,391 L259,328 C259,325.790861 260.790861,324 263,324 Z",
    id: "Rectangle-Copy-11",
    fill: "#003056"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.764151,342 C184.97329,342 186.764151,343.790861 186.764151,346 L186.764151,360 C186.764151,362.209139 184.97329,364 182.764151,364 L76.7641511,364 C74.5550121,364 72.7641511,362.209139 72.7641511,360 L72.7641511,357.381966 L72.7641511,357.381966 C72.608906,357.381966 72.4557929,357.345821 72.3169375,357.276393 L65.5530055,353.894427 C65.059027,353.647438 64.8588026,353.046765 65.1057919,352.552786 C65.2025556,352.359259 65.3594781,352.202337 65.5530055,352.105573 L72.3169375,348.723607 C72.4609351,348.651608 72.6139991,348.617611 72.7647256,348.617816 L72.7641511,346 C72.7641511,343.790861 74.5550121,342 76.7641511,342 L182.764151,342 Z",
    id: "Combined-Shape-Copy-2",
    fill: "#003056"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.764151,342 C410.97329,342 412.764151,343.790861 412.764151,346 L412.764151,360 C412.764151,362.209139 410.97329,364 408.764151,364 L302.764151,364 C300.555012,364 298.764151,362.209139 298.764151,360 L298.764151,357.381966 L298.764151,357.381966 C298.608906,357.381966 298.455793,357.345821 298.316937,357.276393 L291.553005,353.894427 C291.059027,353.647438 290.858803,353.046765 291.105792,352.552786 C291.202556,352.359259 291.359478,352.202337 291.553005,352.105573 L298.316937,348.723607 C298.460935,348.651608 298.613999,348.617611 298.764726,348.617816 L298.764151,346 C298.764151,343.790861 300.555012,342 302.764151,342 L408.764151,342 Z",
    id: "Combined-Shape-Copy-3",
    fill: "#2283FB"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Advance",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    fontFamily: "Lato-Regular, Lato",
    fontSize: 12,
    fontWeight: "normal"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 103,
    y: 357
  }, "Advance")), /*#__PURE__*/React.createElement("text", {
    id: "Advance-Copy",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    fontFamily: "Lato-Regular, Lato",
    fontSize: 12,
    fontWeight: "normal"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 329,
    y: 357
  }, "Advance")), /*#__PURE__*/React.createElement("path", {
    d: "M182,222 C184.209139,222 186,223.790861 186,226 L186,260 C186,262.209139 184.209139,264 182,264 L76,264 C73.790861,264 72,262.209139 72,260 L72,247.381966 L72,247.381966 C71.8447549,247.381966 71.6916418,247.345821 71.5527864,247.276393 L64.7888544,243.894427 C64.2948759,243.647438 64.0946515,243.046765 64.3416408,242.552786 C64.4384045,242.359259 64.595327,242.202337 64.7888544,242.105573 L71.5527864,238.723607 C71.696784,238.651608 71.849848,238.617611 72.0005745,238.617816 L72,226 C72,223.790861 73.790861,222 76,222 L182,222 Z",
    id: "Combined-Shape",
    fill: "#2283FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.764151,299 C184.97329,299 186.764151,300.790861 186.764151,303 L186.764151,317 C186.764151,319.209139 184.97329,321 182.764151,321 L76.7641511,321 C74.5550121,321 72.7641511,319.209139 72.7641511,317 L72.7641511,314.381966 L72.7641511,314.381966 C72.608906,314.381966 72.4557929,314.345821 72.3169375,314.276393 L65.5530055,310.894427 C65.059027,310.647438 64.8588026,310.046765 65.1057919,309.552786 C65.2025556,309.359259 65.3594781,309.202337 65.5530055,309.105573 L72.3169375,305.723607 C72.4609351,305.651608 72.6139991,305.617611 72.7647256,305.617816 L72.7641511,303 C72.7641511,300.790861 74.5550121,299 76.7641511,299 L182.764151,299 Z",
    id: "Combined-Shape-Copy",
    fill: "#0156BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.764151,299 C410.97329,299 412.764151,300.790861 412.764151,303 L412.764151,317 C412.764151,319.209139 410.97329,321 408.764151,321 L302.764151,321 C300.555012,321 298.764151,319.209139 298.764151,317 L298.764151,314.381966 L298.764151,314.381966 C298.608906,314.381966 298.455793,314.345821 298.316937,314.276393 L291.553005,310.894427 C291.059027,310.647438 290.858803,310.046765 291.105792,309.552786 C291.202556,309.359259 291.359478,309.202337 291.553005,309.105573 L298.316937,305.723607 C298.460935,305.651608 298.613999,305.617611 298.764726,305.617816 L298.764151,303 C298.764151,300.790861 300.555012,299 302.764151,299 L408.764151,299 Z",
    id: "Combined-Shape-Copy-4",
    fill: "#2283FB"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Revenue-growth-gener",
    fillRule: "nonzero",
    fontFamily: "Lato-Regular, Lato",
    fontSize: 12,
    fontWeight: "normal",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 78,
    y: 238
  }, "Revenue growth "), /*#__PURE__*/React.createElement("tspan", {
    x: 78,
    y: 253
  }, "generated (for you)")), /*#__PURE__*/React.createElement("text", {
    id: "Fixed-Fee",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    fontFamily: "Lato-Regular, Lato",
    fontSize: 12,
    fontWeight: "normal"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 100,
    y: 314
  }, "Fixed Fee")), /*#__PURE__*/React.createElement("text", {
    id: "Fixed-Fee-Copy",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    fontFamily: "Lato-Regular, Lato",
    fontSize: 12,
    fontWeight: "normal"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 326,
    y: 314
  }, "Fixed Fee")))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgB2BSaas);
export default __webpack_public_path__ + "static/media/b2b-saas.1ade5a48de4935730920b7bb1e2e2b7c.svg";
export { ForwardRef as ReactComponent };